import type { Language } from "./translations";

interface FooterCopy {
  company: string;
  bin: string;
  address: string;
  hours: string;
  services: string;
  site: string;
  documents: string;
  offer: string;
  privacy: string;
  refund: string;
  security: string;
  payment: string;
  paymentSystems: string;
  halyk: string;
  rights: string;
}

export const footerCopy: Record<Language, FooterCopy> = {
  ru: {
    company: "ТОО «ПИР-Kazakhstan»",
    bin: "БИН",
    address: "Республика Казахстан, г. Алматы, ул. Таугуль 52Б",
    hours: "Пн–Пт, 09:00–18:00",
    services: "Сервисы",
    site: "О проекте",
    documents: "Документы",
    offer: "Публичная оферта",
    privacy: "Политика конфиденциальности",
    refund: "Возврат и отмена",
    security: "Безопасность платежей",
    payment:
      "Оплата в казахстанских тенге через защищённую платёжную страницу банка.",
    paymentSystems: "Поддерживаемые платёжные системы",
    halyk: "Сайт платёжной системы Halyk ePay",
    rights: "Все права защищены.",
  },
  kk: {
    company: "«ПИР-Kazakhstan» ЖШС",
    bin: "БСН",
    address: "Қазақстан Республикасы, Алматы қ., Таугүл көшесі, 52Б",
    hours: "Дс–Жм, 09:00–18:00",
    services: "Қызметтер",
    site: "Жоба туралы",
    documents: "Құжаттар",
    offer: "Жария оферта",
    privacy: "Құпиялылық саясаты",
    refund: "Қайтару және бас тарту",
    security: "Төлем қауіпсіздігі",
    payment:
      "Төлем банктің қорғалған төлем беті арқылы қазақстандық теңгемен жүргізіледі.",
    paymentSystems: "Қолдау көрсетілетін төлем жүйелері",
    halyk: "Halyk ePay төлем жүйесінің сайты",
    rights: "Барлық құқықтар қорғалған.",
  },
};
